import{ memo } from "react";
import PostJobForm from "component/postJobForm";

const PostJobFormPage = () =>{
    return (
        <PostJobForm/>
    );
}

export default memo(PostJobFormPage);